// @flow
import React, { Component } from 'react';

import RequiredImmunizations from './RequiredImmunizations.jsx';
import AdditionalImmunizations from './AdditionalImmunizations.jsx';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';

class ImmunizationsPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Immunizations" />
        <ContentBox title="Required Immunizations" id='required'>
          <RequiredImmunizations />
        </ContentBox>
        <ContentBox title="Additional Immunizations" id='additional'>
          <AdditionalImmunizations />
        </ContentBox>
      </div>
    );
  }
}

export default ImmunizationsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/immunization/ImmunizationsPage.jsx